import { Entity } from '@data-client/rest';
class OrganizationReportAccountCountEntity extends Entity {
    constructor() {
        super(...arguments);
        this.licensed = null;
        this.organizationId = 0;
        this.pending = null;
        this.total = 0;
        this.unlicensed = null;
    }
    pk() {
        return btoa(JSON.stringify(this));
    }
}
OrganizationReportAccountCountEntity.key = 'OrganizationReportAccountCount';
export { OrganizationReportAccountCountEntity };
